import React from "react";
import StakedPanel from "components/Panel/StakedPanel";
import PanelNFTs from "components/Panel/helper/PanelNFTs";

const Staked = () => {
    return <PanelNFTs children={<StakedPanel/>}/>;
};

export default Staked;